import { axiosClient } from '../axiosClient';
import { InstaStackDocument } from './types';

type Options = {
  body: InstaStackDocument;
};

export const updateInstastackDocument = ({ body }: Options) => {
  return axiosClient.put<Response>('/instastack/document', body);
};
